import { Translation } from "../../hooks/useTranslations";
import { Entity, Version } from "../../types";
import { CarPurchase } from "../carPurchases/types";
import { Subsidiary } from "../subsidiaries/types";

export type CarPlanningStatus = "to-order" | "to-assign" | "ordered" | "assigned" | "cancelled";
export type CarPlanningTypes = "new-purchase" | "new-leasing" | "re-assignment" | "not-planned-purchase";

export type CarPlanning = Entity & {
  year: number;
  nr: string;
  driverName: string;
  startDate?: string;
  carArrivalDate?: string;
  subsidiary?: Subsidiary;
  subsidiaryCode: string;
  managerName: string;
  costCenter: string;
  costCenterExists?: boolean;
  responsibleId: string;
  status?: CarPlanningStatus;
  type?: CarPlanningTypes;
  priceWithoutVat?: number;
  carPurchase?: CarPurchase;
};

export type UpsertCarPlanning = {
  year: number;
  nr: string;
  driverName: string;
  startDate: string;
  carArrivalDate?: string;
  subsidiaryId: string;
  managerName: string;
  costCenter: string;
  status?: CarPlanningStatus;
  type?: CarPlanningTypes;
  priceWithoutVat?: number;
  currentVersionNumber?: number;
};

export type CarPlanningVersion = Version & {
  year: number;
  nr: string;
  driverName: string;
  startDate: string;
  carArrivalDate?: string;
  subsidiary: Subsidiary;
  managerName: string;
  costCenter: string;
  status?: string;
  type?: string;
  priceWithoutVat: number;
};

export type Status = {
  value: CarPlanningStatus;
  label: string;
};

export const getCarPlanningStates = (i18n: Translation): Status[] => [
  { value: "to-order", label: i18n.common.toOrder },
  { value: "to-assign", label: i18n.common.toAssign },
  { value: "ordered", label: i18n.common.ordered },
  { value: "assigned", label: i18n.common.assigned },
  { value: "cancelled", label: i18n.common.cancelled },
];

export type Types = {
  value: CarPlanningTypes;
  label: string;
};

export const getCarPlanningTypes = (i18n: Translation): Types[] => [
  { value: "new-purchase", label: i18n.common.newOrder },
  { value: "new-leasing", label: i18n.common.newLeasing },
  { value: "re-assignment", label: i18n.common.reAssignment },
  { value: "not-planned-purchase", label: i18n.common.notPlannedPurchase },
];
